import Grid from "@mui/material/Grid/Grid";
import {
  CustomLabelMediumSmallBold,
  CustomLabelSmallMedium,
  CustomLabelSmallRegular,
  CustomLabelXSmallBold,
  CustomLabelXSmallRegular,
} from "../common/CustomLabel";
import XMARK from "../../assets/images/xmark.png";
import Stack from "@mui/material/Stack/Stack";
import LinearProgress from "@mui/material/LinearProgress/LinearProgress";
import Box from "@mui/material/Box/Box";
import { CustomTextField, CustomTextMultipleField } from "../common/text";
import InputAdornment from "@mui/material/InputAdornment/InputAdornment";
import USER from "../../assets/images/user.png";
import MAIL_BLACK from "../../assets/images/mail-black.png";
import ARROW_RIGHT_WITHOUT_BORDER from "../../assets/images/arrow-right-without-border.png";
import Paper from "@mui/material/Paper/Paper";
// import ON_DEMAND_LAPTOP1 from "../../assets/images/on-demand-laptaop-1.png";
// import ON_DEMAND_LAPTOP2 from "../../assets/images/on-demand-laptop-2.png";
// import ON_DEMAND_LAPTOP3 from "../../assets/images/on-demand-laptop-3.png";
import { CustomDropdown } from "../common/CustomDrowDown";
import CODE from "../../assets/images/code.png";
import CLOCK_RIGHT from "../../assets/images/clock-rotate-right.png";
import ARROR_LEFT from "../../assets/images/arrow-left.png";
import TICK from "../../assets/images/tick.png";
import React, { useState } from "react";
import { useMediaQuery } from "@mui/material";
import MenuItem from "@mui/material/MenuItem/MenuItem";
import createTheme from "@mui/material/styles/createTheme";
import SMART_PHONE from "src/assets/images/smartphone-device.png";
import LAPTOP from "src/assets/images/laptop.png";
import { transformValidateObject, validateUserInput } from "../../utils";

import { collection, addDoc } from "firebase/firestore";
import { db } from "src/firebase/firebaseConfig";
import Loader from "../common/Loader";
import KeyboardArrowDown from "@mui/icons-material/KeyboardArrowUp";

import DOLLAR from "../../assets/images/dollar-circle.png";
import { Chip } from "@mui/material";

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 710,
      md: 950,
      lg: 1300,
      xl: 1350,
    },
  },
});

const initialStep1Data = {
  full_name: { value: "", showError: false, error: "Field cant be empty" },
  email: { value: "", showError: false, error: "Field cant be empty" },
  project_title: { value: "", showError: false, error: "Field cant be empty" },
  project_description: {
    value: "",
    showError: false,
    error: "Field cant be empty",
  },
};

const initialStep2Data = {
  project_type: {
    value: "web",
    showError: false,
    error: "Field cant be empty",
  },
  tech_stack: [], 
  showError: false,
  error: "Field cant be empty",
  ux_ui: { value: "no", showError: false, error: "Field cant be empty" },
  ui_ux_link: { value: "", showError: false, error: "Field cant be empty" },
};

const initialStep3Data = {
  budget: { value: "", showError: false, error: "Field cant be empty" },
  project_duration: {
    value: "",
    showError: false,
    error: "Field cant be empty",
  },
  additional_info: {
    value: "",
    showError: false,
    error: "Field cant be empty",
  },
};

const FullProjectDevelopment = ({
  setShowFullProject,
  setShowConfirmation,
}) => {
  // const [isMenuClicked, setIsMenuClicked] = useState(false);

  const [progress, setProgress] = useState(8);

  const [step1, setStep1] = useState(initialStep1Data);
  const [step2, setStep2] = useState(initialStep2Data);
  const [step3, setStep3] = useState(initialStep3Data);
  const [techStackError, setTechStackError] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [count, setCount] = useState(0);

  const saveProject = async (database, data) => {
    try {
      await addDoc(collection(db, database), {
        ...data,
        createdAt: new Date(),
      });
    } catch (error) {
      console.error("Error saving project:", error);
    }
  };

  const onChangeStep1 = (e, type) => {
    let data;
    let value = e.target.value;

    data = { ...step1, [type]: { ...step1[type], value: value } };
    setStep1(data);
  };

  const onChangeStep2 = (e, type) => {
    let data;
    let value = e.target.value;

    data = { ...step2, [type]: { ...step2[type], value: value } };
    setStep2(data);
  };

  const onChangeStep3 = (e, type) => {
    let data;
    let value = e.target.value;

    data = { ...step3, [type]: { ...step3[type], value: value } };
    setStep3(data);
  };

  const onSubmitStep1 = (e) => {
    const validate = validateUserInput(step1);

    if (validate.isValid) {
    setProgress(48);
    } else {
    setStep1(validate.data);
    setCount(count + 1);
    }
  };

  const onSubmitStep2 = (e) => {
    console.log('step2', step2);

    if (Object.keys(selectedTags).length === 0) {
      setTechStackError(true);
      return;
    } else {
      setProgress(90);
      setTechStackError(false);
    }
  };

  const onSubmitStep3 = async (e) => {
    const validate = validateUserInput(step3);

    if (validate.isValid) {
      const data = {
        ...transformValidateObject(step1),
        // ...transformValidateObject(step2),
        project_type: step2.project_type,
        ui_ux_link: step2.ui_ux_link,
        ux_ui: step2.ux_ui,
        tech_stack: step2.tech_stack,
        ...transformValidateObject(step3),
      };
      console.log('data', data);
      setIsLoading(true);
      await saveProject("full-project-development", data);
      setShowFullProject(false);
      setShowConfirmation(true);
      setIsLoading(false);
    } else {
      setStep3(validate.data);
      setCount(count + 1);
    }
  };
  const [selectedTags, setSelectedTags] = useState({});
  const [openCategories, setOpenCategories] = useState({
    "Frontend Development": true,
  });
  const handleCategoryToggle = (category) => {
    setOpenCategories((prev) => ({
      ...prev,
      [category]: !prev[category],
    }));
  };
  const handleTagClick = (tag, category) => {
    // Create updated tags first
    const newSelectedTags = { ...selectedTags };

    // If clicking already selected tag, remove it
    if (newSelectedTags[category] === tag) {
      delete newSelectedTags[category];
    } else {
      // Otherwise set new tag for this category
      newSelectedTags[category] = tag;
    }

    // Update selectedTags state
    setSelectedTags(newSelectedTags);

    // Update step2.tech_stack directly with the new data
    const techStackArray = Object.entries(newSelectedTags).map(([cat, tg]) => ({
      title: cat,
      value: tg,
    }));

    setStep2((prev) => ({
      ...prev,
      tech_stack: techStackArray,
    }));
  };
  const techStackIcons = {
    //   'React.js Developer': REACT_ICON,
    //   'Next.js Developer': NEXT_ICON,
    // ... add more icons
  };

  const techStackPricing = {
    "Web & Frontend Developers": {
      Intermediate: 15,
      Mid_level: 25,
      Senior: 35,
    },
    "Backend Developers": {
      Intermediate: 20,
      Mid_level: 30,
      Senior: 40,
    },
    "Mobile App Developers": {
      Intermediate: 20,
      Mid_level: 30,
      Senior: 40,
    },
    "Full-Stack Developers": {
      Intermediate: 25,
      Mid_level: 35,
      Senior: 45,
    },
    "Software & Windows App Developers": {
      Intermediate: 30,
      Mid_level: 40,
      Senior: 50,
    },
    "Database & Cloud Experts": {
      Intermediate: 25,
      Mid_level: 35,
      Senior: 45,
    },
    "API & Integration Experts": {
      Intermediate: 20,
      Mid_level: 25,
      Senior: 30,
    },
    "Ecommerce Experts": {
      Intermediate: 15,
      Mid_level: 20,
      Senior: 25,
    },
    "DevOps & Cybersecurity": {
      Intermediate: 25,
      Mid_level: 40,
      Senior: 55,
    },
  };
  const TechStackCategory = ({
    title,
    tags,
    isOpen,
    onToggle,
    onTagSelect,
    selectedTags,
    value,
  }) => (
    <Grid item>
      <Grid
        container
        direction="column"
        sx={{
          border: "1px solid #DDDDDD",
          borderRadius: 5,
          background: "white",
          overflow: "hidden",
        }}
      >
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          onClick={onToggle}
          sx={{
            cursor: "pointer",
            padding: "15px",
          }}
        >
          <Grid item>
            <CustomLabelSmallRegular text={title} />
          </Grid>
          <KeyboardArrowDown
            sx={{
              transition: "transform 0.3s ease",
              transform: isOpen ? "rotate(0)" : "rotate(180deg)",
            }}
          />
        </Grid>

        {isOpen && (
          <Grid container spacing={1} sx={{ p: 2 }}>
            {tags.map((tag, index) => (
              <Grid item key={index}>
                <Chip
                  icon={
                    <img
                      src={techStackIcons[tag] || CODE}
                      alt={tag}
                      style={{ width: 16, height: 16 }}
                    />
                  }
                  label={tag}
                  sx={{
                    background: selectedTags.includes(tag)
                      ? "#5E17EB"
                      : "#F5F5F5",
                    borderRadius: "20px",
                    padding: "5px 10px",
                    color: selectedTags.includes(tag) ? "white" : "black",
                    "& .MuiChip-icon": {
                      color: selectedTags.includes(tag) ? "white" : "#666666",
                    },
                    "&:hover": {
                      background: "#5E17EB",
                      color: "white",
                      "& .MuiChip-icon": {
                        color: "white",
                      },
                    },
                  }}
                  onClick={() => onTagSelect(tag, title)}
                />
              </Grid>
            ))}
          </Grid>
        )}
      </Grid>
    </Grid>
  );
  const techStackCategories = {
    "Frontend Developers": [
      "React.js Developer",
      "Next.js Developer",
      "Vue.js Developer",
      "Angular Developer",
      "HTML/CSS/JavaScript Developer",
    ],
    "Backend Developers": [
      "Node.js Developer",
      "Nest.js Developer",
      "Express.js Developer",
      "Laravel/PHP Developer",
      "Python/Django Developer",
      "Golang Developer",
      "Ruby on Rails Developer",
    ],
    "Mobile App Developers": [
      "React Native Developer",
      "Flutter Developer",
      "Kotlin Android Developer",
      "iOS Developer (Swift)",
      "Native App Developer",
    ],
  };

  const getFilteredCategories = (projectType) => {
    if (projectType === "mobile") {
      return {
        "Mobile App Developers": techStackCategories["Mobile App Developers"],
      };
    } else {
      // For web, return all categories except Mobile App Developers
      const { ["Mobile App Developers"]: _, ...webCategories } =
        techStackCategories;
      return webCategories;
    }
  };

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const DeveloperStackListContainer = [
    "MERN (MongoDB, Express.js, React, Node.js)",
    "MEAN (MongoDB, Express.js, Angular, Node.js)",
    "LAMP (Linux, Apache, MySQL, PHP)",
    "LEMP (Linux, Nginx, MySQL, PHP)",
    "JAMstack (JavaScript, APIs, Markup)",
    "Django + PostgreSQL + Nginx",
    "Ruby on Rails + PostgreSQL",
    "Spring Boot + React + MySQL",
  ].map((list) => (
    <MenuItem value={list}>
      <CustomLabelSmallRegular text={list} />
    </MenuItem>
  ));

  const DurationListContainer = [
    "1 Week",
    "2 Weeks",
    "1 Month",
    "3 Months",
    "6 Months",
    "1 Year Or More",
  ].map((list) => (
    <MenuItem value={list}>
      <CustomLabelSmallRegular text={list} />
    </MenuItem>
  ));

  const handleClickOutside = (e) => {
    if (e.target === e.currentTarget) {
      setShowFullProject(false);
    }
  };
  return (
    <>
      <Grid
        container
        className="modal-overlay"
        onClick={handleClickOutside}
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.1)",
          zIndex: 1000,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Grid item onClick={(e) => e.stopPropagation()}>
          {isLoading && <Loader />}
          <Grid
            direction={"row"}
            container
            item
            xs={12}
            sm={10}
            md={8}
            lg={5.5}
            justifyContent={"center"}
            sx={{
              position: "fixed",
              top: 0,
              right: 0,
              zIndex: 11,
              padding: { xs: "20px 10px", sm: "40px", md: "40px" },
              background: "#FAF7FF",
              borderRadius: "25px 0px 0px 25px",
              overflowY: "scroll",
              height: "100%",
            }}
          >
            <form>
              <Grid
                item
                container
                justifyContent={"space-between"}
                alignItems={"center"}
              >
                <Grid item xs={9}>
                  <CustomLabelMediumSmallBold
                    text={"Full Project Development"}
                    color={"#5E17EB"}
                  />
                </Grid>
                <Grid item>
                  <Grid item container justifyContent={"center"}>
                    <Grid
                      item
                      container
                      style={{
                        border: "1.5px solid #DDDDDD",
                        background: "white",
                        borderRadius: "20px",
                        width: "56px",
                        height: "56px",
                        cursor: "pointer",
                      }}
                      alignItems={"center"}
                      justifyContent={"center"}
                      onClick={(e) => setShowFullProject(false)}
                    >
                      <Grid item>
                        <img src={XMARK} alt={"XMARK"} />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <Grid
                item
                container
                sx={{ marginTop: { xs: "20px", md: "20px" } }}
              >
                <CustomLabelSmallRegular
                  text={
                    "Tell us about your project, and we'll handle the rest."
                  }
                />
              </Grid>

              <Grid
                item
                container
                xs={12}
                sx={{ marginTop: { xs: "20px", md: "40px" } }}
              >
                <Stack spacing={2} sx={{ flex: 1, position: "relative" }}>
                  <LinearProgress
                    variant="determinate"
                    value={progress}
                    sx={{
                      height: 10,
                      borderRadius: 5,
                      border: "1px solid #DDDDDD",
                      backgroundColor: "white", // Background color
                      "& .MuiLinearProgress-bar": {
                        backgroundColor: "#5E17EB", // Progress bar color
                      },
                    }}
                  />
                  <Box
                    sx={{
                      position: "absolute",
                      top: -10,
                      left: `calc(${progress}% - 10px)`,
                      transform: "translateY(-50%)",
                      width: 15,
                      height: 15,
                      borderRadius: "50%",
                      backgroundColor: "#5E17EB",
                      border: "1px solid white",
                      boxShadow: "0 0 5px rgba(0,0,0,0.5)",
                      transition: "left 0.5s ease",
                    }}
                  />
                </Stack>
                <Grid
                  container
                  justifyContent={"space-between"}
                  style={{ marginTop: "5px" }}
                >
                  <Grid item>
                    <CustomLabelSmallMedium
                      text={"Basic Info"}
                      color={"#5E17EB"}
                    />
                  </Grid>
                  <Grid item>
                    <CustomLabelSmallMedium
                      text={"Project Requirements"}
                      color={"#5E17EB"}
                    />
                  </Grid>
                  <Grid item>
                    <CustomLabelSmallMedium
                      color={"#5E17EB"}
                      text={"Budget & Scope"}
                    />
                  </Grid>
                </Grid>

                {progress === 8 && (
                  <Grid
                    container
                    sx={{ marginTop: { xs: "30px", md: "40px" } }}
                  >
                    <Grid item xs={12} container justifyContent={"flex-start"}>
                      <Grid item style={{ marginLeft: 10 }}>
                        <CustomLabelXSmallRegular text={"Full Name"} />
                      </Grid>
                      <Grid item container style={{ marginTop: 5 }}>
                        <CustomTextField
                          placeholder={"Type your full name here..."}
                          height={isMobile && "50px"}
                          value={step1.full_name.value}
                          onChange={(e) => onChangeStep1(e, "full_name")}
                          error={step1.full_name.showError}
                          helperText={
                            step1.full_name.showError
                              ? step1.full_name.error
                              : ""
                          }
                          startAdornment={
                            <InputAdornment position="start">
                              <img src={USER} alt={"USER"} />
                            </InputAdornment>
                          }
                          otherInputProps={{
                            sx: {
                              "&.MuiOutlinedInput-root": {
                                backgroundColor: "white",
                              },
                              "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                {
                                  borderColor: "#5E17EB",
                                  borderWidth: "1px",
                                },
                            },
                          }}
                        />
                      </Grid>
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      container
                      justifyContent={"flex-start"}
                      style={{ marginTop: "20px" }}
                    >
                      <Grid item style={{ marginLeft: 10 }}>
                        <CustomLabelXSmallRegular text={"Email Address"} />
                      </Grid>
                      <Grid item container style={{ marginTop: 5 }}>
                        <CustomTextField
                          placeholder={"example@email.com"}
                          height={isMobile && "50px"}
                          value={step1.email.value}
                          onChange={(e) => onChangeStep1(e, "email")}
                          error={step1.email.showError}
                          helperText={
                            step1.email.showError ? step1.email.error : ""
                          }
                          startAdornment={
                            <InputAdornment position="start">
                              <img src={MAIL_BLACK} alt={"MAIL_BLACK"} />
                            </InputAdornment>
                          }
                          otherInputProps={{
                            sx: {
                              "&.MuiOutlinedInput-root": {
                                backgroundColor: "white",
                              },
                              "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                {
                                  borderColor: "#5E17EB",
                                  borderWidth: "1px",
                                },
                            },
                          }}
                        />
                      </Grid>
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      container
                      justifyContent={"flex-start"}
                      style={{ marginTop: "20px" }}
                    >
                      <Grid item style={{ marginLeft: 10 }}>
                        <CustomLabelXSmallRegular text={"Project Title"} />
                      </Grid>
                      <Grid item container style={{ marginTop: 5 }}>
                        <CustomTextField
                          placeholder={"Type here..."}
                          height={isMobile && "50px"}
                          value={step1.project_title.value}
                          onChange={(e) => onChangeStep1(e, "project_title")}
                          error={step1.project_title.showError}
                          helperText={
                            step1.project_title.showError
                              ? step1.project_title.error
                              : ""
                          }
                          otherInputProps={{
                            sx: {
                              "&.MuiOutlinedInput-root": {
                                backgroundColor: "white",
                              },
                              "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                {
                                  borderColor: "#5E17EB",
                                  borderWidth: "1px",
                                },
                            },
                          }}
                        />
                      </Grid>
                    </Grid>

                    <Grid container style={{ marginTop: "20px" }}>
                      <Grid item style={{ marginLeft: 10 }}>
                        <CustomLabelXSmallRegular
                          text={"Project Description"}
                        />
                      </Grid>
                      <Grid item container style={{ marginTop: 5 }}>
                        <CustomTextMultipleField
                          placeholder={"What's on your mind?"}
                          rows={5}
                          value={step1.project_description.value}
                          onChange={(e) =>
                            onChangeStep1(e, "project_description")
                          }
                          error={step1.project_description.showError}
                          helperText={
                            step1.project_description.showError
                              ? step1.project_description.error
                              : ""
                          }
                          otherInputProps={{
                            sx: {
                              "&.MuiOutlinedInput-root": {
                                backgroundColor: "white",
                              },
                              "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                {
                                  borderColor: "#5E17EB",
                                  borderWidth: "1px",
                                },
                            },
                          }}
                        />
                      </Grid>
                    </Grid>

                    <Grid
                      item
                      container
                      justifyContent={"center"}
                      style={{ marginTop: "10px" }}
                    >
                      <div>
                        <Grid
                          container
                          alignItems={"center"}
                          justifyContent={"center"}
                          sx={{
                            border: "1.5px solid #F5F5F5",
                            borderRadius: "20px",
                            padding: { xs: "10px 40px", md: "12px 60px" },
                            background: "#5E17EB",
                            marginTop: "20px",
                            cursor: "pointer",
                          }}
                          onClick={onSubmitStep1}
                        >
                          <Grid item>
                            <CustomLabelSmallMedium
                              text={"Next"}
                              color={"white"}
                            />
                          </Grid>

                          <Grid
                            item
                            style={{ marginLeft: "5px", marginTop: "4px" }}
                          >
                            <img src={ARROW_RIGHT_WITHOUT_BORDER} alt={"ARROW_RIGHT_WITHOUT_BORDER"} />
                          </Grid>
                        </Grid>
                      </div>
                    </Grid>
                  </Grid>
                )}

                {progress === 48 && (
                  <>
                    <Grid container>
                      <Grid
                        container
                        sx={{ marginTop: { xs: "30px", md: "40px" } }}
                      >
                        <Grid
                          item
                          xs={12}
                          container
                          justifyContent={"flex-start"}
                        >
                          <Grid item style={{ marginLeft: 10 }}>
                            <CustomLabelXSmallRegular
                              text={
                                "What type of project are you looking to build?"
                              }
                            />
                          </Grid>
                          <Grid item container style={{ marginTop: 5 }}>
                            <Grid container justifyContent={"space-between"}>
                              <Grid item xs={5.5}>
                                <Paper
                                  onClick={(e) =>
                                    onChangeStep2(
                                      { target: { value: "mobile" } },
                                      "project_type"
                                    )
                                  }
                                  sx={{
                                    width: "100%",
                                    background: "white",
                                    padding: {
                                      xs: "20px 0px",
                                      md: "20px 10px",
                                    },
                                    borderRadius: "25px",
                                    cursor: "pointer",
                                    border:
                                      step2.project_type.value === "mobile" &&
                                      "1px solid #5E17EB",
                                  }}
                                >
                                  <Grid
                                    container
                                    alignItems={"center"}
                                    direction={"column"}
                                  >
                                    <Grid item>
                                      <img
                                        src={SMART_PHONE}
                                        style={{ height: "48px" }}
                                        alt={"SMART_PHONE"}
                                      />
                                    </Grid>
                                    <Grid item style={{ marginTop: "5px" }}>
                                      <CustomLabelXSmallBold
                                        text={"Mobile App "}
                                        color={
                                          step2.project_type.value === "mobile"
                                            ? "#5E17EB"
                                            : "#A3A3A3"
                                        }
                                      />
                                    </Grid>
                                    <Grid></Grid>
                                  </Grid>
                                </Paper>
                              </Grid>
                              <Grid item xs={5.5}>
                                <Paper
                                  onClick={(e) =>
                                    onChangeStep2(
                                      { target: { value: "web" } },
                                      "project_type"
                                    )
                                  }
                                  sx={{
                                    width: "100%",
                                    background: "white",
                                    padding: {
                                      xs: "20px 0px",
                                      md: "20px 10px",
                                    },
                                    borderRadius: "25px",
                                    cursor: "pointer",
                                    border:
                                      step2.project_type.value === "web" &&
                                      "1px solid #5E17EB",
                                  }}
                                >
                                  <Grid
                                    container
                                    alignItems={"center"}
                                    direction={"column"}
                                  >
                                    <Grid item>
                                      <img
                                        src={LAPTOP}
                                        style={{ height: "48px" }}
                                        alt={"LAPTOP"}
                                      />
                                    </Grid>
                                    <Grid item style={{ marginTop: "5px" }}>
                                      <CustomLabelXSmallBold
                                        text={"Web/Desktop App "}
                                        color={
                                          step2.project_type.value === "web"
                                            ? "#5E17EB"
                                            : "#A3A3A3"
                                        }
                                      />
                                    </Grid>
                                    <Grid></Grid>
                                  </Grid>
                                </Paper>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>

                        {/* <Grid item xs={12} container justifyContent={"flex-start"} style={{marginTop: "20px"}}>
                                    <Grid item style={{marginLeft: 10}}>
                                        <CustomLabelXSmallRegular
                                            text={"Which tech stack or framework do you prefer?"}/>
                                    </Grid>
                                    <Grid item container style={{marginTop: 5}}>
                                        <CustomDropdown
                                                        height={isMobile && "50px"}
                                                        multiple={true}
                                                        container={DeveloperStackListContainer}
                                                        value={step2.language_stack_required.value}
                                                        short={true}
                                                        placeholder={"React, Node.js, Python, etc."}
                                                        onChange={(e) => onChangeStep2(e, "language_stack_required")}
                                                        showError={step2.language_stack_required.showError}
                                                        error={step2.language_stack_required.showError ? step2.language_stack_required.error : ""}

                                                        startAdornment={
                                                            <InputAdornment position="start">
                                                                <img src={CODE}/>
                                                            </InputAdornment>

                                                        }/>
                                    </Grid>
                                </Grid> */}

                        <Grid
                          container
                          direction="column"
                          spacing={1}
                          sx={{ mt: 1 }}
                        >
                          {Object.entries(
                            getFilteredCategories(step2.project_type.value)
                          ).map(([category, tags]) => (
                            <TechStackCategory
                              key={category}
                              title={category}
                              tags={tags}
                              isOpen={openCategories[category]}
                              onToggle={() => handleCategoryToggle(category)}
                              onTagSelect={handleTagClick}
                              selectedTags={Object.values(selectedTags)}
                              value={step2.tech_stack.map(item => item.value || "")}
                            />
                          ))}
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          container
                          justifyContent={"flex-start"}
                          style={{ marginTop: "20px" }}
                        >
                          <Grid item style={{ marginLeft: 10 }}>
                            <CustomLabelXSmallRegular
                              text={
                                "Do you need UI/UX design as part of the project?"
                              }
                            />
                          </Grid>
                          <Grid item container style={{ marginTop: 5 }}>
                            <Grid container justifyContent={"space-between"}>
                              <Grid item xs={5.5}>
                                <Paper
                                  onClick={(e) =>
                                    onChangeStep2(
                                      { target: { value: "yes" } },
                                      "ux_ui"
                                    )
                                  }
                                  sx={{
                                    width: "90%",
                                    background: "white",
                                    padding: {
                                      xs: "15px 0px",
                                      md: "15px 10px",
                                    },
                                    borderRadius: "25px",
                                    cursor: "pointer",
                                    border:
                                      step2.ux_ui.value === "yes"
                                        ? "1px solid #5E17EB"
                                        : "1px solid #DDDDDD",
                                  }}
                                >
                                  <Grid
                                    container
                                    alignItems={"center"}
                                    direction={"column"}
                                  >
                                    <Grid item>
                                      <CustomLabelXSmallBold
                                        text={"Yes "}
                                        color={
                                          step2.ux_ui.value === "yes"
                                            ? "#5E17EB"
                                            : "#A3A3A3"
                                        }
                                      />
                                    </Grid>
                                  </Grid>
                                </Paper>
                              </Grid>
                              <Grid item xs={5.5}>
                                <Paper
                                  onClick={(e) =>
                                    onChangeStep2(
                                      { target: { value: "no" } },
                                      "ux_ui"
                                    )
                                  }
                                  sx={{
                                    width: "90%",
                                    background: "white",
                                    padding: {
                                      xs: "15px 0px",
                                      md: "15px 10px",
                                    },
                                    borderRadius: "25px",
                                    cursor: "pointer",
                                    border:
                                      step2.ux_ui.value === "no"
                                        ? "1px solid #5E17EB"
                                        : "1px solid #DDDDDD",
                                  }}
                                >
                                  <Grid
                                    container
                                    alignItems={"center"}
                                    direction={"column"}
                                  >
                                    <Grid item>
                                      <CustomLabelXSmallBold
                                        text={"No "}
                                        color={
                                          step2.ux_ui.value === "no"
                                            ? "#5E17EB"
                                            : "#A3A3A3"
                                        }
                                      />
                                    </Grid>
                                  </Grid>
                                </Paper>
                              </Grid>
                            </Grid>
                          </Grid>

                          {step2.ux_ui.value === "no" && (
                            <>
                              <Grid
                                item
                                style={{ marginLeft: 10, marginTop: "20px" }}
                              >
                                <CustomLabelXSmallRegular
                                  text={"You have UI/UX design? share link"}
                                />
                              </Grid>
                              <Grid item container style={{ marginTop: 5 }}>
                                <CustomTextField
                                  placeholder="Paste your design link here"
                                  value={step2.ui_ux_link.value}
                                  onChange={(e) => onChangeStep2(e, 'ui_ux_link')}
                                  showError={step2.ui_ux_link.showError}
                                  error={step2.ui_ux_link.showError ? step2.ui_ux_link.error : ""}
                                  fullWidth
                                  // startAdornment={
                                  //     <InputAdornment position="start">
                                  //         <LinkIcon />
                                  //     </InputAdornment>
                                  // }
                                  otherInputProps={{
                                    sx: {
                                      "&.MuiOutlinedInput-root": {
                                        backgroundColor: "white",
                                      },
                                      "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                        {
                                          borderColor: "#5E17EB",
                                          borderWidth: "1px",
                                        },
                                    },
                                  }}
                                />
                              </Grid>
                            </>
                          )}
                        </Grid>

                        <Grid
                          item
                          container
                          justifyContent={"center"}
                          sx={{ paddingBottom: "40px", marginTop: "20px" }}
                        >
                          <div>
                            <Grid
                              container
                              alignItems={"center"}
                              justifyContent={"center"}
                              sx={{
                                border: "1.5px solid #DDDDDD",
                                borderRadius: "20px",
                                padding: {
                                  xs: "10px 25px",
                                  sm: "10px 40px",
                                  md: "12px 80px",
                                },
                                background: "white",
                                marginTop: "20px",
                                gap: "5px",
                                cursor: "pointer"
                              }}
                              onClick={(e) => setProgress(8)}
                            >
                              <Grid item style={{ marginTop: "2px" }}>
                                <img src={ARROR_LEFT} alt={"ARROR_LEFT"} />
                              </Grid>

                              <Grid item>
                                <CustomLabelSmallMedium
                                  text={"Back"}
                                  color={"black"}
                                />
                              </Grid>
                            </Grid>
                          </div>

                          <div style={{ marginLeft: "20px" }}>
                            <Grid
                              container
                              alignItems={"center"}
                              justifyContent={"center"}
                              sx={{
                                border: "1.5px solid #F5F5F5",
                                borderRadius: "20px",
                                padding: {
                                  xs: "10px 25px",
                                  sm: "10px 40px",
                                  md: "12px 80px",
                                },
                                background: "#5E17EB",
                                marginTop: "20px",
                                gap: "5px",
                                cursor: "pointer"
                              }}
                              onClick={onSubmitStep2}
                            >
                              <Grid item>
                                <CustomLabelSmallMedium
                                  text={"Next"}
                                  color={"white"}
                                />
                              </Grid>

                              <Grid item style={{ marginTop: "4px" }}>
                                <img src={ARROW_RIGHT_WITHOUT_BORDER} alt={"ARROW_RIGHT_WITHOUT_BORDER"} />
                              </Grid>
                            </Grid>
                          </div>
                        </Grid>
                      </Grid>
                    </Grid>
                  </>
                )}

                {progress === 90 && (
                  <>
                    <Grid container>
                      <Grid
                        container
                        sx={{ marginTop: { xs: "30px", md: "40px" } }}
                      >
                        <Grid
                          item
                          xs={12}
                          container
                          justifyContent={"flex-start"}
                        >
                          <Grid
                            item
                            xs={12}
                            container
                            justifyContent={"flex-start"}
                          >
                            <Grid item style={{ marginLeft: 10 }}>
                              <CustomLabelXSmallRegular
                                text={"What's your estimated budget? "}
                              />
                            </Grid>
                            <Grid item container style={{ marginTop: 5 }}>
                              <CustomTextField
                                placeholder={"Type your budget here..."}
                                height={isMobile && "50px"}
                                value={step3.budget.value}
                                type={"number"}
                                onChange={(e) => onChangeStep3(e, "budget")}
                                error={step3.budget.showError}
                                helperText={
                                  step3.budget.showError
                                    ? step3.budget.error
                                    : ""
                                }
                                startAdornment={
                                  <InputAdornment position="start">
                                    <img src={DOLLAR} alt={"DOLLAR"} />
                                  </InputAdornment>
                                }
                                otherInputProps={{
                                    sx: {
                                      "&.MuiOutlinedInput-root": {
                                        backgroundColor: "white",
                                      },
                                      "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                        {
                                          borderColor: "#5E17EB",
                                          borderWidth: "1px",
                                        },
                                    },
                                  }}
                              />
                            </Grid>
                          </Grid>
                        </Grid>

                        <Grid
                          item
                          xs={12}
                          container
                          justifyContent={"flex-start"}
                          style={{ marginTop: "20px" }}
                        >
                          <Grid item style={{ marginLeft: 10 }}>
                            <CustomLabelXSmallRegular
                              text={
                                "What's the estimated duration of the project?"
                              }
                            />
                          </Grid>
                          <Grid item xs={12} container style={{ marginTop: 5 }}>
                            <CustomDropdown
                              height={isMobile && "50px"}
                              container={DurationListContainer}
                              value={[step3.project_duration.value]}
                              placeholder={"Select.."}
                              onChange={(e) =>
                                onChangeStep3(e, "project_duration")
                              }
                              showError={step3.project_duration.showError}
                              error={
                                step3.project_duration.showError
                                  ? step3.project_duration.error
                                  : ""
                              }
                              startAdornment={
                                <InputAdornment position="start">
                                  <img src={CLOCK_RIGHT} alt={"CLOCK_RIGHT"} />
                                </InputAdornment>
                              }
                              
                            />
                          </Grid>
                        </Grid>

                        <Grid
                          item
                          xs={12}
                          container
                          justifyContent={"flex-start"}
                          style={{ marginTop: "15px" }}
                        >
                          <Grid item style={{ marginLeft: 10 }}>
                            <CustomLabelXSmallRegular
                              text={"Additional Information"}
                            />
                          </Grid>
                          <Grid item container style={{ marginTop: 5 }}>
                            <CustomTextMultipleField
                              onChange={(e) =>
                                onChangeStep3(e, "additional_info")
                              }
                              error={step3.additional_info.showError}
                              helperText={
                                step3.additional_info.showError
                                  ? step3.additional_info.error
                                  : ""
                              }
                              value={step3.additional_info.value}
                              placeholder={"Write something here..."}
                              rows={5}
                              otherInputProps={{
                                sx: {
                                  "&.MuiOutlinedInput-root": {
                                    backgroundColor: "white",
                                  },
                                  "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                    {
                                      borderColor: "#5E17EB",
                                      borderWidth: "1px",
                                    },
                                },
                              }}
                            />
                          </Grid>
                        </Grid>

                        <Grid
                          item
                          container
                          justifyContent={"center"}
                          sx={{ paddingBottom: "40px", marginTop: "20px" }}
                        >
                          <div>
                            <Grid
                              container
                              alignItems={"center"}
                              justifyContent={"center"}
                              sx={{
                                border: "1.5px solid #DDDDDD",
                                borderRadius: "10px",
                                padding: { xs: "10px 15px", md: "8px 80px" },
                                background: "white",
                                marginTop: "20px",
                                gap: "5px",
                                cursor: "pointer",
                              }}
                              onClick={(e) => setProgress(48)}
                            >
                              <Grid item style={{ marginTop: "2px" }}>
                                <img src={ARROR_LEFT} alt={"ARROR_LEFT"} />
                              </Grid>

                              <Grid item>
                                <CustomLabelSmallMedium
                                  text={"Back"}
                                  color={"black"}
                                />
                              </Grid>
                            </Grid>
                          </div>

                          <div style={{ marginLeft: "20px" }}>
                            <Grid
                              container
                              alignItems={"center"}
                              justifyContent={"center"}
                              sx={{
                                border: "1.5px solid #F5F5F5",
                                borderRadius: "10px",
                                padding: { xs: "10px 15px", md: "12px 80px" },
                                background: "#5E17EB",
                                marginTop: "20px",
                                gap: "10px",
                                cursor: "pointer",
                              }}
                              onClick={(e) => {
                                //setShowOnDemandDevelopers(false)
                                //setShowConfirmation(true)
                                onSubmitStep3(e);
                              }}
                            >
                              <Grid item>
                                <CustomLabelSmallMedium
                                  text={"Submit"}
                                  color={"white"}
                                />
                              </Grid>

                              <Grid item>
                                <img src={TICK} alt={"TICK"} />
                              </Grid>
                            </Grid>
                          </div>
                        </Grid>
                      </Grid>
                    </Grid>
                  </>
                )}
              </Grid>
            </form>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default FullProjectDevelopment;
